import React from "react";

const ContactInfo = () => {
  return (
    <div className="flex-1 flex-col h-fit w-full  radius-10 back-white  align-left justify-start  pt-3 pb-2 pl-3 pr-3 g-2">
      <div className="w-full flex-col align-left justify-start g-1">
        <h3 className="t-16 color-grayColor poppins-medium weight-500">
          Contact info
        </h3>
        <hr color="#e5e5e5" className="w-full" />
      </div>
      <div className="flex-col flex-1 scroll-y align-left justify-start g-1 w-full">
        <div className="flex-col align-left justify-start g-05">
          <span className="t-12 poppins color-grayColor">Email us:</span>
          <span className="t-12 poppins color-textColor">
            Oms.org.in@gmail.com
          </span>
        </div>
        <div className="flex-col align-left justify-start g-05">
          <span className="t-12 poppins color-grayColor">Contact number:</span>
          <span className="t-12 poppins color-textColor">9876543210</span>
        </div>
        <div className="flex-col align-left justify-start g-05">
          <span className="t-12 poppins color-grayColor">Address:</span>
          <span className="t-12 poppins color-textColor">
            Abc street, Kolkata, 700342
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
